// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description Holds information about the Member Number Bucket that was determined
*/
export class EnrollmentV2RulesMemberNumberBucketResult {
    /**
    * @description Bucket Name
    */
    'bucketName'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EnrollmentV2RulesMemberNumberBucketResult>> = [
        {
            "name":     "bucketName",
            "baseName": "bucketName",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return EnrollmentV2RulesMemberNumberBucketResult.attributeTypeMap;
    }
}
